import { useNavigate, useRoutes } from 'react-router-dom';
import { useRoutesConst } from '.';
import Error from '../views/error';
import Layout from '../layout';
import Home from '../views/home';
import SuccessReservation from '../views/successReservation';
import { useEffectOnce } from 'react-use';
import NoMatch from '../views/NoMatch';
import ReactGA from 'react-ga4';
import ReservationPolicy from '../views/scheduleMeeting/reservationPolicy';
import ReportAbusePage from '../views/reportAbuse';
import ReportAbuseSuccess from '../views/reportAbuse/success';
import LinkExpired from '../views/linkExpired';

const Routes = () => {
  const { ROUTES } = useRoutesConst();

  useEffectOnce(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
    });
  });

  const routes = useRoutes([
    {
      element: <Layout />,
      path: '/success',
      errorElement: <NoMatch />,
      children: [
        {
          index: true,
          element: <SuccessReservation />,
        },
      ],
    },
    {
      element: <Layout />,
      path: '/reservation-policy',
      errorElement: <NoMatch />,
      children: [
        {
          index: true,
          element: <ReservationPolicy />,
        },
      ],
    },
    // New format with tenant slug: /tenant-domain/member-slug
    {
      path: '/:tenantSlug/:client',
      element: <Layout />,
      errorElement: <NoMatch />,
      children: [
        {
          index: true,
          element: ROUTES.Services.component,
        },
        {
          path: ROUTES.ScheduleMeeting.path,
          element: ROUTES.ScheduleMeeting.component,
        },
        {
          path: ROUTES.rescheduleMeeting.path,
          element: ROUTES.rescheduleMeeting.component,
        },
        {
          path: ROUTES.Voting.path,
          element: ROUTES.Voting.component,
        },
        {
          path: ROUTES.personalData.path,
          element: ROUTES.personalData.component,
        },
      ],
    },
    // Old format without tenant slug (backward compatibility): /member-slug
    {
      path: '/:client',
      element: <Layout />,
      errorElement: <NoMatch />,
      children: [
        {
          index: true,
          element: ROUTES.Services.component,
        },
        {
          path: ROUTES.ScheduleMeeting.path,
          element: ROUTES.ScheduleMeeting.component,
        },
        {
          path: ROUTES.rescheduleMeeting.path,
          element: ROUTES.rescheduleMeeting.component,
        },
        {
          path: ROUTES.personalData.path,
          element: ROUTES.personalData.component,
        },
        {
          path: ROUTES.Voting.path,
          element: ROUTES.Voting.component,
        },
      ],
    },
    {
      path: 'profile',
      element: <Home />,
      children: [
        {
          index: true,
          element: ROUTES.accountInformation.component,
        },
        {
          path: ROUTES.accountInformation.path,
          element: ROUTES.accountInformation.component,
        },
        {
          path: ROUTES.myAppointment.path,
          element: ROUTES.myAppointment.component,
        },
      ],
    },
    {
      path: '*',
      element: <NoMatch />,
    },
    {
      path: '/404',
      element: <NoMatch />,
    },
    {
      path: ROUTES.MessagePage.path,
      element: ROUTES.MessagePage.component,
    },
    {
      path: ROUTES.FormPage.path,
      element: ROUTES.FormPage.component,
    },
    // Form page with tenant slug support
    {
      path: ':tenantSlug/form/:id',
      element: ROUTES.FormPage.component,
    },
    {
      path: ROUTES.Voting.path,
      element: ROUTES.Voting.component,
    },
    {
      path: ROUTES.successVoting.path,
      element: ROUTES.successVoting.component,
    },
    {
      path: 'report-abuse',
      element: <ReportAbusePage />,
    },
    {
      path: 'report-abuse-success',
      element: <ReportAbuseSuccess />,
    },
    {
      path: '/error',
      element: <Error />,
    },
    {
      path: '/link-expired',
      element: <LinkExpired />,
    },
  ]);
  return routes;
};

export default Routes;
